<template>
  <div class="withdraw_wrap">
    <!-- <div class="base-header">
      <div class="big_tit" @click="$router.push('recharge')">{{ $t('充值') }}</div>
      <div :class="is_active ? 'big_tit is-active' : 'big_tit'">{{ $t('提现') }}</div>
    </div> -->
    <!-- <div class="logo">
      <img src="../../assets/images/logo/logo.png" />
    </div> -->
    <div class="left_div">
      <div class="left" @click="$router.push('/')">
        <svg width="1em" height="1em" fill="" aria-hidden="true" focusable="false">
          <symbol id="comm_icon_fh--svgSprite:all" viewBox="0 0 21.999 35.998">
            <path id="comm_icon_fh--svgSprite:all_comm_icon_fh"
              d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
              transform="translate(-2190.681 -102.15)" />
          </symbol>
          <use xlink:href="#comm_icon_fh--svgSprite:all" />
        </svg>
      </div>

      <van-tabs v-model="active" animated offset-top="1.2rem" lazy-render class="vantTabs" @change="tabChange">
        <van-tab :title="$t('请求提款')" />
        <van-tab :title="$t('收据账户')" />
        <van-tab :title="$t('提币记录')" />
        <!-- <van-tab title="Conta para recebimento" /> -->
      </van-tabs>
      <div style="margin-left: .3rem;" @click.stop="toSupport">
        <svg width="25" height="25" class="kefu" viewBox="0 0 30 30">
          <defs>
            <clipPath id="EePOvn3Q-clip-path">
              <rect id="EePOvn3Q-Rectangle_2801" data-name="Rectangle 2801" width="30" height="30"
                transform="translate(-2 -4)" />
            </clipPath>
          </defs>
          <g id="EePOvn3Q-icon_sys_menu_service" transform="translate(2 4)" clip-path="url(#EePOvn3Q-clip-path)">
            <path id="EePOvn3Q-Path_6350" data-name="Path 6350"
              d="M81.876,1430.6a.372.372,0,0,1-.445-.36v-4.15c0-.553.212-.641.445-.7a2.165,2.165,0,0,1,1.794,2.091v1.033A2.157,2.157,0,0,1,81.876,1430.6Zm-2.743,1.667H75.711a1.008,1.008,0,0,1-1.032-.978v-6.577a1,1,0,0,1,1.032-.977H77.62a6.743,6.743,0,0,0-6.765-6.361,6.857,6.857,0,0,0-6.765,6.361H66a1,1,0,0,1,1.032.977v6.577a1.008,1.008,0,0,1-1.032.978H64.6v.553a1.74,1.74,0,0,0,1.779,1.69h1.764a2.3,2.3,0,0,1,1.836-1.138h1.748a2.089,2.089,0,0,1,2.147,1.915,2.329,2.329,0,0,1-2.147,2.187H69.981a3.578,3.578,0,0,1-1.826-1.13H66.38a3.577,3.577,0,0,1-3.432-3.525v-.553h-.327a1.008,1.008,0,0,1-1.032-.978v-7.49a.048.048,0,0,1,.013-.032,9.269,9.269,0,0,1,18.5,0,.048.048,0,0,1,.013.032v7.49A1,1,0,0,1,79.133,1432.269Zm-19.3-1.667a2.083,2.083,0,0,1-1.643-2.083v-1.033a2.092,2.092,0,0,1,1.643-2.091c.232.056.444.144.444.7v4.15A.372.372,0,0,1,59.834,1430.6Z"
              transform="translate(-58.038 -1415.012)" />
          </g>

        </svg>
      </div>
    </div>

    <div v-show="active == 0">
      <div class="ablewd">
        <div>
          <div class="left-ab">
            <div class="desc-ab">
              {{ $t('账户余额') }}
            </div>
            <!-- <img class="jinbi" src="../../assets/images/common/a04.png" /> -->
            <div class="desc-num">
              {{ able_money }}
            </div>
            <div class="wdAble" @click="hasWithdrawPassword">
              <svg width="1.2em" height="1.2em" fill="" aria-hidden="true" focusable="false">
                <symbol id="comm_icon_sx--svgSprite:all" viewBox="0 0 24 25.144">
                  <path id="comm_icon_sx--svgSprite:all_comm_icon_sx"
                    d="M1520.314-127.2l5.058-9.146,2.1,3.9a10.844,10.844,0,0,0,4.845-9.038c0-3.028-2-6.031-4-8,3.919,1.639,7.43,5.773,7.43,10.285a10.856,10.856,0,0,1-6.549,9.964l1.977,3.179Zm-8.572-10.858a10.86,10.86,0,0,1,6.548-9.965l-1.976-3.178,10.857,1.142-5.06,9.147-2.095-3.9a10.842,10.842,0,0,0-4.847,9.039c0,3.028,2,6.031,4,8C1515.255-129.409,1511.743-133.543,1511.743-138.055Z"
                    transform="translate(-1511.743 151.198)" />
                </symbol>
                <use xlink:href="#comm_icon_sx--svgSprite:all" />
              </svg>
            </div>
          </div>
          <div class="money_title">
            <span>{{ $t('你需要下注') }} </span>
            <span class="rmoney">R$ {{ need_bet }}</span>
            <span> {{ $t('取款') }}</span>
          </div>
        </div>
      </div>
      <div class="enther">
        <div v-if="!holdBind" class="addBind_box" @click="toAddBind">
          <div class="box_title">
            <i>
              <svg width="25" height="25" class="kefu" viewBox="0 0 40 27.611">
                <g id="IqWNLZNz-img_tx_tjzh" transform="translate(-1939.301 287.188)">
                  <path id="IqWNLZNz-Path_520" data-name="Path 520"
                    d="M1977.03-283.677a3.486,3.486,0,0,0-3.461-3.51h-30.807a3.486,3.486,0,0,0-3.461,3.51v3.017h37.729Z"
                    fill-rule="evenodd" />
                  <path id="IqWNLZNz-Path_521" data-name="Path 521"
                    d="M1958.38-262.572a11.712,11.712,0,0,1,5.108-9.678H1939.3v15.084a3.486,3.486,0,0,0,3.461,3.511H1962.5A11.694,11.694,0,0,1,1958.38-262.572Z"
                    transform="translate(0 -6.198)" fill-rule="evenodd" />
                  <path id="IqWNLZNz-Path_522" data-name="Path 522"
                    d="M1985.436-271.42a9.192,9.192,0,0,0-9.192,9.193,9.192,9.192,0,0,0,9.192,9.192,9.193,9.193,0,0,0,9.193-9.192A9.193,9.193,0,0,0,1985.436-271.42Zm5.089,9.186a1.025,1.025,0,0,1-1.017,1.032h-3.061v3.1a1.024,1.024,0,0,1-1.017,1.032h0a1.024,1.024,0,0,1-1.017-1.032v-3.1h-3.042a1.024,1.024,0,0,1-1.017-1.032v0a1.024,1.024,0,0,1,1.017-1.031h3.042v-3.086a1.024,1.024,0,0,1,1.017-1.031h0a1.024,1.024,0,0,1,1.017,1.031v3.086h3.061a1.024,1.024,0,0,1,1.017,1.031Z"
                    transform="translate(-15.328 -6.542)" fill-rule="evenodd" />
                </g>
              </svg>
            </i>
            <span>{{ $t('添加提款账户') }}</span>
          </div>
          <div>
            <i>
              <svg width="1em" height="1em" style="transform: rotate(180deg);" class="kefu" viewBox="0 0 21.999 35.998">
                <path id="agWk0trb-comm_icon_fh"
                  d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
                  transform="translate(-2190.681 -102.15)" />

              </svg>
            </i>
          </div>
        </div>
        <div class="cpfDiv">
          <el-select v-model="bindValue" popper-class="setSelect" :placeholder="$t('选择银行卡')"
            :popper-append-to-body="false" @change="selectChange">
            <template #prefix>
              <img src="../../assets/images/index/icon_normal_pix.png" alt=""
                style="width: 20px;height: 20px;margin-top: 6px;">
            </template>
            <el-option v-for="item in bindList" :key="item.id"
              :label="item.chave_pix + '(' + hiddenPhoneNumber(item.pix || item.cpf) + ')'" :value="item.id">
              <span style="display: flex;align-items: center;">
                <img src="../../assets/images/index/icon_normal_pix.png" alt="">
                <span class="selectBind" style="margin-left: .2rem;font-size: .3rem; margin-right: .1rem;">{{
                  item.chave_pix }} ({{
                    hiddenPhoneNumber(item.pix || item.cpf)
                  }})</span><span class="selectBind" /></span>
            </el-option>
          </el-select>
          <i @click="toAddBind()">
            <svg width="30" height="30" class="kefu" viewBox="0 0 45 33">
              <g id="hjB4AAsB-icon_tx_txgl" transform="translate(-599.998 -1034.128)">
                <rect id="hjB4AAsB-矩形_3513" data-name="矩形 3513" width="45" height="33"
                  transform="translate(599.998 1034.128)" opacity="0" />
                <g id="hjB4AAsB-icon_wd_txgl" transform="translate(600.448 1035.255)">
                  <path id="hjB4AAsB-Shape_19" data-name="Shape 19"
                    d="M4.716,27.977A4.721,4.721,0,0,1,0,23.251V11.087H29.215a11.97,11.97,0,0,0-4.338,16.89ZM3.394,15.5a1.635,1.635,0,0,0,1.634,1.636H9.7a1.636,1.636,0,1,0,0-3.272H5.028A1.635,1.635,0,0,0,3.394,15.5ZM0,7.816V4.725A4.721,4.721,0,0,1,4.716,0H33.35a4.721,4.721,0,0,1,4.716,4.725v3.09Z"
                    transform="translate(0)" />
                  <path id="hjB4AAsB-Shape_19-2" data-name="Shape 19"
                    d="M676.932,1074.442l-1.68-1.317a6.874,6.874,0,0,0,.04-.692,6.711,6.711,0,0,0-.04-.692l1.683-1.317a.827.827,0,0,0,.2-1.052l-1.747-3.03a.81.81,0,0,0-1.011-.364l-1.984.8a6.851,6.851,0,0,0-1.192-.693l-.3-2.107a.81.81,0,0,0-.807-.7h-3.506a.81.81,0,0,0-.806.7l-.3,2.115a6.97,6.97,0,0,0-1.189.692l-1.988-.8a.826.826,0,0,0-1,.36l-1.75,3.034a.823.823,0,0,0,.2,1.057l1.681,1.316a6.088,6.088,0,0,0,0,1.382l-1.683,1.318a.825.825,0,0,0-.2,1.052l1.747,3.03a.81.81,0,0,0,1.012.364l1.98-.8a6.876,6.876,0,0,0,1.191.692l.3,2.106a.81.81,0,0,0,.81.7h3.5a.81.81,0,0,0,.807-.7l.3-2.115a7.02,7.02,0,0,0,1.188-.693l1.99.8a.826.826,0,0,0,.3.057.8.8,0,0,0,.7-.414l1.755-3.046A.824.824,0,0,0,676.932,1074.442Zm-8.595,2.569a4.576,4.576,0,1,1,4.568-4.576,4.576,4.576,0,0,1-4.568,4.576Z"
                    transform="translate(-633.14 -1050.995)" />
                </g>
                <g id="hjB4AAsB-Stroke_Effect" data-name="Stroke Effect" transform="translate(599.998 1035.006)"
                  opacity="0.01">
                  <path id="hjB4AAsB-路径_21825" data-name="路径 21825"
                    d="M33.446,30.6a.81.81,0,0,1-.81-.7l-.3-2.107a6.88,6.88,0,0,1-1.191-.693l-1.98.8a.81.81,0,0,1-1.012-.364L26.4,24.5a.826.826,0,0,1,.2-1.052l1.683-1.318a6.106,6.106,0,0,1,0-1.383L26.6,19.43a.824.824,0,0,1-.2-1.058l1.75-3.034a.826.826,0,0,1,1-.36l1.988.8a7,7,0,0,1,1.189-.693l.3-2.115a.81.81,0,0,1,.807-.695H36.95a.81.81,0,0,1,.805.7l.3,2.108a6.8,6.8,0,0,1,1.192.693l1.984-.8a.81.81,0,0,1,1.011.364l1.747,3.031a.828.828,0,0,1-.2,1.052l-1.681,1.318a6.828,6.828,0,0,1,.04.692c0,.251-.02.489-.04.692l1.68,1.316a.825.825,0,0,1,.2,1.046l-1.755,3.047a.8.8,0,0,1-.7.414.821.821,0,0,1-.3-.056l-1.989-.8a7.006,7.006,0,0,1-1.187.693l-.3,2.115a.81.81,0,0,1-.807.7Zm-2.817-9.163A4.568,4.568,0,1,0,35.2,16.861,4.568,4.568,0,0,0,30.629,21.438ZM4.716,27.976A4.721,4.721,0,0,1,0,23.25V11.087H29.216a11.97,11.97,0,0,0-4.338,16.89ZM3.394,15.5a1.635,1.635,0,0,0,1.634,1.635H9.7a1.636,1.636,0,1,0,0-3.272H5.028A1.635,1.635,0,0,0,3.394,15.5ZM0,7.816V4.725A4.721,4.721,0,0,1,4.716,0H33.351a4.721,4.721,0,0,1,4.716,4.725v3.09Z"
                    transform="translate(0.45 0.45)" fill="none" />
                  <path id="hjB4AAsB-路径_21826" data-name="路径 21826"
                    d="M36.4,30.05a.808.808,0,0,0,.806-.7l.3-2.115a7.006,7.006,0,0,0,1.187-.693l1.99.8a.821.821,0,0,0,.3.056.8.8,0,0,0,.7-.414l1.756-3.047a.825.825,0,0,0-.2-1.046l-1.68-1.317c.02-.2.04-.44.04-.691a6.828,6.828,0,0,0-.04-.692l1.683-1.317a.828.828,0,0,0,.2-1.052l-1.747-3.031a.809.809,0,0,0-1.011-.364l-1.984.8a6.8,6.8,0,0,0-1.191-.693l-.3-2.108a.808.808,0,0,0-.806-.7H32.894a.809.809,0,0,0-.806.7l-.3,2.116a7,7,0,0,0-1.189.693l-1.988-.8a.826.826,0,0,0-1,.358l-1.75,3.034a.824.824,0,0,0,.2,1.058L27.734,20.2a6.106,6.106,0,0,0,0,1.383L26.052,22.9a.826.826,0,0,0-.2,1.052L27.6,26.98a.808.808,0,0,0,1.012.364l1.982-.8a6.882,6.882,0,0,0,1.191.692l.3,2.108a.81.81,0,0,0,.808.7h3.5M34.646,16.311a4.577,4.577,0,1,1-4.567,4.577,4.572,4.572,0,0,1,4.567-4.577M24.328,27.426a11.97,11.97,0,0,1,4.338-16.89H-.55V22.7a4.721,4.721,0,0,0,4.715,4.726H24.328M4.478,13.315H9.146a1.636,1.636,0,0,1,0,3.272H4.478a1.636,1.636,0,0,1,0-3.272M37.517,7.266V4.175A4.72,4.72,0,0,0,32.8-.55H4.165A4.721,4.721,0,0,0-.55,4.175v3.09H37.517M36.4,30.5H32.9a1.261,1.261,0,0,1-1.254-1.094l-.267-1.864a7.366,7.366,0,0,1-.837-.487l-1.756.707-.013,0a1.337,1.337,0,0,1-.463.084,1.256,1.256,0,0,1-1.1-.649l-1.745-3.027,0-.009a1.278,1.278,0,0,1,.312-1.62l0,0,1.49-1.167c-.013-.173-.019-.334-.019-.488s.006-.315.019-.488l-1.488-1.165,0,0a1.276,1.276,0,0,1-.307-1.636l1.747-3.029a1.278,1.278,0,0,1,1.109-.64,1.238,1.238,0,0,1,.449.083l.005,0,1.763.71a7.407,7.407,0,0,1,.834-.488l.267-1.873a1.258,1.258,0,0,1,1.252-1.085H36.4a1.258,1.258,0,0,1,1.252,1.093l.267,1.864a7.28,7.28,0,0,1,.838.488l1.758-.707.011,0a1.323,1.323,0,0,1,.462-.084,1.256,1.256,0,0,1,1.1.649L43.832,17.6l.005.009a1.28,1.28,0,0,1-.312,1.62l0,0L42.032,20.4c.011.147.02.313.02.489s-.009.338-.02.488l1.487,1.166,0,0a1.276,1.276,0,0,1,.319,1.614l0,.009-1.753,3.042a1.248,1.248,0,0,1-1.1.643,1.274,1.274,0,0,1-.462-.087l-.006,0-1.764-.71a7.41,7.41,0,0,1-.833.488l-.269,1.873A1.256,1.256,0,0,1,36.4,30.5ZM34.646,16.761a4.127,4.127,0,1,0,4.118,4.127A4.126,4.126,0,0,0,34.646,16.761ZM24.328,27.876H4.165A5.177,5.177,0,0,1-1,22.7V10.537a.45.45,0,0,1,.45-.45H28.666a.45.45,0,0,1,.218.844,11.52,11.52,0,0,0-4.175,16.256.45.45,0,0,1-.381.69ZM4.478,13.765a1.186,1.186,0,0,0,0,2.372H9.146a1.186,1.186,0,0,0,0-2.372ZM37.517,7.716H-.55A.45.45,0,0,1-1,7.266V4.175A5.176,5.176,0,0,1,4.165-1H32.8a5.17,5.17,0,0,1,5.166,5.175v3.09A.45.45,0,0,1,37.517,7.716Z"
                    transform="translate(1 1)" />
                </g>
              </g>

            </svg>
          </i>
        </div>
        <div class="bind_input">
          <div class="input_item">
            <span>R$</span>
            <input v-model="money" type="text" class="amount-input" :placeholder="'Mínimo ' + this.min_withdraw_amount">
          </div>
        </div>
        <div style="margin-top: 0.5rem" @click="submit">
          <van-button type="primary">
            {{ $t('确认') }}
          </van-button>
        </div>
      </div>
    </div>
    <div v-show="active == 1">
      <div class="bind_box">
        <div class="bindCard">
          <div class="bindCard-title">
            {{ $t('收据账户') }} <span style="margin-left: .2rem;margin-right: .2rem;">({{ bindList.length
            }}/5)</span>
            <!-- <i>
              <svg width="15" height="15" class="kefu" viewBox="0 0 27.675 28">
                <path id="x7zTTOLE-comm_icon_retry"
                  d="M0,18.972l9.548-.161L7.155,22.229a10.746,10.746,0,1,0-4.056-8.4c0,.306.013.617.04.921H.057c-.021-.3-.03-.612-.03-.921A13.827,13.827,0,0,1,26.586,8.443a13.824,13.824,0,0,1-21.2,16.313L3.113,28Z">
                </path>

              </svg>
            </i> -->
          </div>
          <div class="bindCard-list">
            <div v-for="(item, index) in bindList" :class="listActive == item.id ? 'list listActive' : 'list'"
              @click="updateBind(item)">
              <div>
                <img src="../../assets/images/active/03.png" alt="">
              </div>
              <div class="list-center">
                <span>PIX</span>
                <span>({{ item.chave_pix }})</span>
                <div class="copy">
                  {{ hiddenPhoneNumber(item.pix || item.cpf) }} <span @click.stop="doCopy(item.pix || item.cpf)"><img
                      src="../../assets/images/active/04.png" alt=""></span>
                </div>
              </div>
              <div v-if="listActive != item.id" class="list-right" @click.stop="changeBind(item, index)">
                {{ $t('设置为默认值') }}
              </div>
              <div v-if="listActive == item.id" class="tag">
                <img src="../../assets/images/active/05.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="addBind" @click="addBind">
          <div class="pix_box">
            <div class="left">
              <img src="../../assets/images/index/icon_normal_pix.png" alt="">
              <i>PIX</i>
            </div>
            <div class="right">
              <i>{{ $t('添加') }}</i>
              <i>
                <svg width="20" style="transform: rotate(180deg);" height="20" fill="currentColor"
                  viewBox="0 0 21.999 35.998">
                  <path id="agWk0trb-comm_icon_fh"
                    d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
                    transform="translate(-2190.681 -102.15)" />

                </svg>
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="active == 2">
      <div class="select_items">
        <div class="flex_select">
          <div class="select_item">
            <select id="history" v-model="select_history_time" name="history" @change="selectHistoryimeChange">
              <option value="0" :selected="select_history_time == '0'">
                {{ $t("今天") }}
              </option>
              <option value="1" :selected="select_history_time == '1'">
                {{ $t("昨天") }}
              </option>
              <option value="7" :selected="select_history_time == '7'">
                {{ $t("最近7天") }}
              </option>
              <option value="15" :selected="select_history_time == '15'">
                {{ $t("最近15天") }}
              </option>
              <option value="30" :selected="select_history_time == '30'">
                {{ $t("最近30天") }}
              </option>
            </select>
          </div>
        </div>

        <div class="bonus">
          {{ $t('提款总额') }}:
          <span style="margin-right: 0.3rem">R$ {{ re_list.total }}</span>
        </div>
      </div>
      <div v-for="(item, k) in re_list.list" :key="k" class="recharge-one">
        <div class="order-status">
          <div>{{ $t('网上支付') }}</div>
          <div class="mmm">
            {{ item.money }}
          </div>
        </div>
        <div class="order-status">
          <div>{{ item.order_no }}</div>
          <div @click="doCopy(item.order_no)">
            <svg data-v-fa159fb6="" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 26 26"
              fill="none">
              <g data-v-fa159fb6="" clip-path="url(#clip0_2451_66251)">
                <g data-v-fa159fb6="" clip-path="url(#clip1_2451_66251)">
                  <path data-v-fa159fb6=""
                    d="M10.1064 5.85938H20.5844C21.7549 5.8607 22.8771 6.32627 23.7048 7.15396C24.5325 7.98165 24.9981 9.10385 24.9994 10.2744V20.7524C24.9981 21.9229 24.5325 23.0451 23.7048 23.8728C22.8771 24.7005 21.7549 25.1661 20.5844 25.1674H10.1064C8.93588 25.1661 7.81368 24.7005 6.98599 23.8728C6.15831 23.0451 5.69273 21.9229 5.69141 20.7524V10.2744C5.69273 9.10385 6.15831 7.98165 6.98599 7.15396C7.81368 6.32627 8.93588 5.8607 10.1064 5.85938ZM20.5844 22.7164C21.1052 22.7161 21.6046 22.5091 21.9729 22.1408C22.3411 21.7726 22.5481 21.2732 22.5484 20.7524V10.2744C22.5466 9.75461 22.3388 9.25675 21.9708 8.88979C21.6027 8.52282 21.1042 8.31664 20.5844 8.31637H10.1064C9.58768 8.31822 9.09073 8.5251 8.72393 8.8919C8.35713 9.25869 8.15025 9.75565 8.14841 10.2744V20.7524C8.14867 21.2721 8.35485 21.7706 8.72182 22.1387C9.08878 22.5068 9.58664 22.7145 10.1064 22.7164H20.5844Z"
                    fill="currentColor" />
                  <path data-v-fa159fb6=""
                    d="M3.46995 20.87C3.29252 20.8705 3.11713 20.8323 2.95599 20.758C2.79485 20.6837 2.65185 20.5752 2.53695 20.44C1.54592 19.2806 1.00156 17.8053 1.00195 16.28V7.406C1.00381 5.70794 1.67904 4.07993 2.87957 2.87903C4.08009 1.67813 5.70789 1.00238 7.40595 1H16.284C17.1489 0.999689 18.005 1.17472 18.8004 1.51452C19.5959 1.85431 20.3142 2.35183 20.912 2.977C21.1245 3.2141 21.2364 3.52458 21.2241 3.84275C21.2118 4.16092 21.0762 4.46182 20.846 4.68178C20.6157 4.90174 20.309 5.0235 19.9906 5.0213C19.6722 5.0191 19.3671 4.89312 19.14 4.67C18.7721 4.28252 18.3289 3.97433 17.8376 3.76436C17.3463 3.55439 16.8172 3.44708 16.283 3.449H7.40595C6.35726 3.45059 5.35201 3.86809 4.61075 4.60992C3.86949 5.35174 3.45275 6.3573 3.45195 7.406V16.284C3.45168 17.2247 3.78713 18.1346 4.39795 18.85C4.54919 19.0279 4.64647 19.2453 4.67834 19.4767C4.71021 19.708 4.67536 19.9436 4.57787 20.1558C4.48039 20.368 4.32433 20.548 4.12806 20.6745C3.93179 20.801 3.70347 20.8688 3.46995 20.87Z"
                    fill="currentColor" />
                </g>
              </g>
              <defs data-v-fa159fb6="">
                <clipPath id="clip0_2451_66251" data-v-fa159fb6="">
                  <rect data-v-fa159fb6="" width="26" height="26" fill="currentColor" />
                </clipPath>
                <clipPath id="clip1_2451_66251" data-v-fa159fb6="">
                  <rect data-v-fa159fb6="" width="26" height="26" fill="currentColor" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div v-if="item.remark" class="order-status">
          <div>{{ item.remark }}</div>
        </div>
        <div class="money3">
          <div class="order">
            {{ item.time }}
          </div>
          <div :class="item.status == 1 ? 'status' : 'unpay'">
            <b v-if="item.status == 1">{{ $t("已付款") }}</b>
            <b v-else-if="item.status == 0">{{ $t('付费') }}</b>
            <b v-else-if="item.status == 2">{{ $t('付款失败') }}</b>
          </div>
        </div>
      </div>
    </div>
    <pay-layer ref="payLayer" v-model="show_pay" @inputEnd="handleInputEnd" @close="handleClose"
      @forgetPassword="handleForget" />
    <van-popup v-model="showPopup" position="center">
      <div class="pasTitle">
        {{ $t('输入密码') }}
      </div>
      <div class="pasTips">
        <span>{{ $t('提现密码') }}</span><span><van-icon name="lock" class="lock_icon" /></span>
      </div>
      <div class="fst_pw">
        <input-password v-model="addPassword" @changeItem="addPasswordChange" />
      </div>
      <div class="pasTips">
        <span>{{ $t('为了您的账户安全，请输入提现密码') }}</span><span class="green" @click="toSupport">{{ $t('忘记密码')
        }}?</span>
      </div>
      <div class="pasButton" @click="verifyPassword">
        {{ $t('下一个') }}
      </div>
    </van-popup>
    <van-popup v-model="showBindPopup" position="center">
      <div class="pasTitle">
        {{ $t('添加') }} PIX
      </div>
      <div class="">
        <div class="input_item">
          <span>
            <svg width="1em" height="1em" class="blueSvg" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="8oEJWekg-clip-path">
                  <path id="8oEJWekg-Union_151" data-name="Union 151"
                    d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)" />
                </clipPath>
              </defs>
              <g id="8oEJWekg-input_icon_zsxm" transform="translate(-2397 -2123)">
                <g id="8oEJWekg-底层" transform="translate(2397 2123)">
                  <g id="8oEJWekg-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                    clip-path="url(#8oEJWekg-clip-path)">
                    <path id="8oEJWekg-底层-2" data-name="底层"
                      d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                      transform="translate(0 0)" />
                  </g>
                </g>
                <path id="8oEJWekg-icon_dl_zsxm"
                  d="M-10927.969-3139.318h-40a4,4,0,0,1-4-4l0-26.181a4,4,0,0,1,4-3.995h40a4,4,0,0,1,4,4v26.18a4.005,4.005,0,0,1-4,4Zm-29.248-27.293a5.683,5.683,0,0,0-5.711,5.646,5.561,5.561,0,0,0,2.292,4.531c-3.457,2.287-6.107,4.362-6.338,8.463a1.773,1.773,0,0,0,.47,1.309,1.308,1.308,0,0,0,.938.417h16.688a1.312,1.312,0,0,0,.94-.412,1.8,1.8,0,0,0,.476-1.309c-.239-4.111-2.893-6.184-6.339-8.465a5.606,5.606,0,0,0,2.295-4.53,5.686,5.686,0,0,0-5.7-5.65Zm16.5,12.364a2.251,2.251,0,0,0-2.247,2.251,2.245,2.245,0,0,0,2.247,2.247h10.5a2.25,2.25,0,0,0,2.25-2.247,2.25,2.25,0,0,0-2.25-2.251Zm0-9a2.249,2.249,0,0,0-2.25,2.247,2.251,2.251,0,0,0,2.25,2.253h10.5a2.254,2.254,0,0,0,2.25-2.254,2.249,2.249,0,0,0-2.25-2.247Z"
                  transform="translate(13368.967 5303.495)" />
              </g>

            </svg>
          </span>
          <input v-model="bindObj.name" type="text" class="amount-input" :placeholder="$t('输入您的真实姓名')">
        </div>
        <div class="input_item">
          <span>
            <div class="phoneIcon" />
          </span>
          <span v-if="bindObj.phone_number" class="pre">+55</span>
          <input v-model="bindObj.phone_number" type="text" class="amount-input" :placeholder="$t('输入您的电话号码')">
        </div>
        <div class="input_item">
          <span>
            <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="5imfv5QN-clip-path">
                  <path id="5imfv5QN-Union_151" data-name="Union 151"
                    d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)" />
                </clipPath>
              </defs>
              <g id="5imfv5QN-input_icon_cpf" transform="translate(-696.5 -2123)">
                <g id="5imfv5QN-底层" transform="translate(696.5 2123)">
                  <g id="5imfv5QN-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                    clip-path="url(#5imfv5QN-clip-path)">
                    <path id="5imfv5QN-底层-2" data-name="底层"
                      d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                      transform="translate(0 0)" />
                  </g>
                </g>
                <path id="5imfv5QN-icon_dl_cpf"
                  d="M43.772,34.34H4.228A4.231,4.231,0,0,1,0,30.109V4.228A4.231,4.231,0,0,1,4.228,0H43.772A4.231,4.231,0,0,1,48,4.228V30.109a4.231,4.231,0,0,1-4.228,4.228Zm-7.6-27.229a5.625,5.625,0,0,0-5.647,5.583,5.524,5.524,0,0,0,2.267,4.477c-3.417,2.258-6.044,4.3-6.264,8.367A1.759,1.759,0,0,0,27,26.821a1.292,1.292,0,0,0,.932.412H44.422a1.292,1.292,0,0,0,.932-.412,1.745,1.745,0,0,0,.465-1.281c-.231-4.069-2.856-6.109-6.264-8.367a5.531,5.531,0,0,0,2.265-4.479,5.625,5.625,0,0,0-5.647-5.583ZM6.129,12.033a3.884,3.884,0,0,0-2.079.552,3.6,3.6,0,0,0-1.375,1.6,5.714,5.714,0,0,0-.48,2.4v.572a5.038,5.038,0,0,0,1.041,3.36,3.583,3.583,0,0,0,2.873,1.231,4,4,0,0,0,2.677-.873,3.308,3.308,0,0,0,1.119-2.4H7.959a1.839,1.839,0,0,1-.511,1.27,1.935,1.935,0,0,1-1.344.41,1.647,1.647,0,0,1-1.473-.711,4.145,4.145,0,0,1-.467-2.232v-.722a3.912,3.912,0,0,1,.5-2.164,1.676,1.676,0,0,1,1.468-.7,1.887,1.887,0,0,1,1.331.41,2,2,0,0,1,.511,1.331H9.914a3.585,3.585,0,0,0-1.15-2.457,3.868,3.868,0,0,0-2.633-.873Zm13.615.124v9.458h1.944V17.745H25.42V16.178H21.689V13.745h4.22V12.157Zm-8.561,0v9.458h1.942V18.279h1.713a3.993,3.993,0,0,0,2.633-.8,2.708,2.708,0,0,0,.949-2.193,3.092,3.092,0,0,0-.436-1.636,2.9,2.9,0,0,0-1.244-1.108,4.268,4.268,0,0,0-1.879-.391Zm3.683,4.553H13.119V13.745h1.791a1.527,1.527,0,0,1,1.128.436,1.58,1.58,0,0,1,.406,1.128,1.337,1.337,0,0,1-.406,1.041,1.7,1.7,0,0,1-1.176.367Z"
                  transform="translate(696.5 2129.5)" />
              </g>

            </svg>
          </span>
          <input v-model="bindObj.cpf" type="text" class="amount-input" :placeholder="$t('输入 11 位 CPF 号码')">
        </div>
        <div class="input_item">
          <span>
            <svg width="1em" height="1em" class="blueSvg" viewBox="0 0 48 48.001">
              <defs>
                <clipPath id="ggCHVIDK-clip-path">
                  <path id="ggCHVIDK-Union_151" data-name="Union 151"
                    d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)" />
                </clipPath>
              </defs>
              <g id="ggCHVIDK-input_icon_zh" transform="translate(-2322 -2123)">
                <g id="ggCHVIDK-底层" transform="translate(2322 2123)">
                  <g id="ggCHVIDK-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                    clip-path="url(#ggCHVIDK-clip-path)">
                    <path id="ggCHVIDK-底层-2" data-name="底层"
                      d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                      transform="translate(0 0)" />
                  </g>
                </g>
                <path id="ggCHVIDK-icon_dl_zh"
                  d="M4.328,46.837A3.348,3.348,0,0,1,1,43.473v-.147A22.079,22.079,0,0,1,12.009,25.609a17.332,17.332,0,0,0,23.875,0A22.072,22.072,0,0,1,46.87,43.326,3.344,3.344,0,0,1,43.7,46.833h-.149Zm7.185-33.4A12.419,12.419,0,1,1,24.054,25.675h-.119A12.327,12.327,0,0,1,11.513,13.442Z"
                  transform="translate(2322 2123.163)" />
              </g>

            </svg>
          </span>
          <select id="country" v-model="bindObj.chave_pix" name="country" class="amount-input selectpix"
            @change="selectPix">
            <option value="PIX_CPF" :selected="bindObj.chave_pix == 'PIX_CPF'">
              PIX_CPF
            </option>
            <!-- <option value="PIX_CNPJ" :selected="bindObj.chave_pix == 'PIX_CNPJ'">
              PIX_CNPJ
            </option> -->
            <option value="PIX_PHONE" :selected="bindObj.chave_pix == 'PIX_PHONE'">
              PIX_PHONE
            </option>
          </select>
        </div>

        <div class="input_item">
          <span>
            <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 30 29.987">
              <path
                d="M11.726 28.609q-2.758-2.755-5.518-5.518c-.027-.028-.059-.05-.087-.075l.014-.041h.861a4.261 4.261 0 0 0 3.041-1.263c1.494-1.479 2.974-2.97 4.46-4.455a.861.861 0 0 1 1.365 0l4.4 4.4a4.245 4.245 0 0 0 2.811 1.283c.259.016.518 0 .776 0 0 .016.007.034.011.05-.031.034-.059.071-.092.1l-5.578 5.575a4.36 4.36 0 0 1-2.781 1.29q-.226.019-.451.02a4.435 4.435 0 0 1-3.231-1.372zm-7.239-7.233c-1.04-1.052-2.09-2.092-3.136-3.138a4.563 4.563 0 0 1-.034-6.452c1.1-1.122 2.224-2.227 3.334-3.341a.259.259 0 0 1 .29-.1.96.96 0 0 0 .282.011h1.7a3.049 3.049 0 0 1 2.23.928c1.476 1.472 2.963 2.935 4.419 4.426a2.231 2.231 0 0 0 3.214 0c1.461-1.488 2.946-2.952 4.42-4.428a3.114 3.114 0 0 1 2.23-.923h.586c.311 0 .623.007.932-.011a.592.592 0 0 1 .507.216c1.047 1.06 2.1 2.11 3.157 3.163a4.464 4.464 0 0 1 1.348 2.856c.011.132.025.265.029.344a4.569 4.569 0 0 1-1.33 3.273q-1.622 1.63-3.254 3.256a.476.476 0 0 1-.405.171c-.332-.02-.666-.018-1-.014h-.519a3.184 3.184 0 0 1-2.32-.959c-1.446-1.456-2.9-2.9-4.347-4.355a2.23 2.23 0 0 0-1.666-.713 2.121 2.121 0 0 0-1.528.636q-2.217 2.219-4.435 4.435a3.115 3.115 0 0 1-2.33.964c-.591-.007-1.18-.029-1.766.011h-.061a.708.708 0 0 1-.545-.256zm10.038-8.627c-1.491-1.488-2.978-2.984-4.472-4.467a4.263 4.263 0 0 0-3.071-1.274h-.845l-.02-.048c.061-.055.127-.105.186-.164q2.742-2.741 5.487-5.481a4.365 4.365 0 0 1 2.792-1.3 4.44 4.44 0 0 1 3.659 1.338c1.845 1.835 3.678 3.679 5.521 5.518.034.034.075.064.114.1l-.015.05h-.437a4.322 4.322 0 0 0-2.505.766 4.489 4.489 0 0 0-.641.531q-2.224 2.206-4.439 4.431a.837.837 0 0 1-1.312 0z"
                transform="translate(.002 .006)" style="fill:#00bdae" />

            </svg>
          </span>
          <input v-if="bindObj.chave_pix === 'PIX_CPF'" v-model="bindObj.cpf" type="text" class="amount-input"
            :placeholder="$t('输入您的 PIX 密钥')" disabled>
          <template v-else-if="bindObj.chave_pix === 'PIX_PHONE'">
            <span class="pre">+55</span>
            <input v-model="bindObj.phone_number" type="text" class="amount-input" :placeholder="$t('输入您的 PIX 密钥')"
              disabled>
          </template>
          <input v-else-if="bindObj.chave_pix === 'PIX_CNPJ'" v-model="bindObj.pix" type="text" class="amount-input"
            :placeholder="$t('输入您的 PIX 密钥')">
        </div>
        <!-- <div class="input_item">
          <span>
            <svg
              width="1em"
              height="1em"
              fill="currentColor"
              viewBox="0 0 30 29.987"
            >
              <path
                d="M11.726 28.609q-2.758-2.755-5.518-5.518c-.027-.028-.059-.05-.087-.075l.014-.041h.861a4.261 4.261 0 0 0 3.041-1.263c1.494-1.479 2.974-2.97 4.46-4.455a.861.861 0 0 1 1.365 0l4.4 4.4a4.245 4.245 0 0 0 2.811 1.283c.259.016.518 0 .776 0 0 .016.007.034.011.05-.031.034-.059.071-.092.1l-5.578 5.575a4.36 4.36 0 0 1-2.781 1.29q-.226.019-.451.02a4.435 4.435 0 0 1-3.231-1.372zm-7.239-7.233c-1.04-1.052-2.09-2.092-3.136-3.138a4.563 4.563 0 0 1-.034-6.452c1.1-1.122 2.224-2.227 3.334-3.341a.259.259 0 0 1 .29-.1.96.96 0 0 0 .282.011h1.7a3.049 3.049 0 0 1 2.23.928c1.476 1.472 2.963 2.935 4.419 4.426a2.231 2.231 0 0 0 3.214 0c1.461-1.488 2.946-2.952 4.42-4.428a3.114 3.114 0 0 1 2.23-.923h.586c.311 0 .623.007.932-.011a.592.592 0 0 1 .507.216c1.047 1.06 2.1 2.11 3.157 3.163a4.464 4.464 0 0 1 1.348 2.856c.011.132.025.265.029.344a4.569 4.569 0 0 1-1.33 3.273q-1.622 1.63-3.254 3.256a.476.476 0 0 1-.405.171c-.332-.02-.666-.018-1-.014h-.519a3.184 3.184 0 0 1-2.32-.959c-1.446-1.456-2.9-2.9-4.347-4.355a2.23 2.23 0 0 0-1.666-.713 2.121 2.121 0 0 0-1.528.636q-2.217 2.219-4.435 4.435a3.115 3.115 0 0 1-2.33.964c-.591-.007-1.18-.029-1.766.011h-.061a.708.708 0 0 1-.545-.256zm10.038-8.627c-1.491-1.488-2.978-2.984-4.472-4.467a4.263 4.263 0 0 0-3.071-1.274h-.845l-.02-.048c.061-.055.127-.105.186-.164q2.742-2.741 5.487-5.481a4.365 4.365 0 0 1 2.792-1.3 4.44 4.44 0 0 1 3.659 1.338c1.845 1.835 3.678 3.679 5.521 5.518.034.034.075.064.114.1l-.015.05h-.437a4.322 4.322 0 0 0-2.505.766 4.489 4.489 0 0 0-.641.531q-2.224 2.206-4.439 4.431a.837.837 0 0 1-1.312 0z"
                transform="translate(.002 .006)"
                style="fill:#00bdae"
              />

            </svg>
          </span>
          <input
            v-model="bindObj.phone_number"
            type="text"
            class="amount-input"
            placeholder="Digite o seu número de telefone"
          >
        </div>
      </div> -->
        <div class="pasTips_bottom">
          {{ $t('确认姓名和卡以确保资金存入。') }}
        </div>
        <div class="bindButton" @click="addBindCon">
          {{ $t("确认") }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {
  NavBar,
  Tab,
  Tabs,
  Field,
  Button,
  Popup,
  DropdownMenu,
  DropdownItem,
} from "vant";
import ft from "../../components/ft.vue";
import ftNav from "../../components/footer_nav/footer_nav";
import payLayer from "vue-pay-layer-pt";
import InputPassword from "../../components/password";
import { EventBus } from '../../utils/utils'

Vue.use(payLayer)
  .use(NavBar)
  .use(Tab)
  .use(Tabs)
  .use(Field)
  .use(Button)
  .use(Popup)
  .use(DropdownMenu)
  .use(DropdownItem);
export default {
  name: "Cost",
  components: {
    ft,
    ftNav,
    InputPassword,
  },
  data() {
    return {
      updId: "",
      isUpd: false,
      listActive: "",
      active: 0,
      able_money: 0, //可以提现金额
      money: null,
      phone_number: "",
      chave_pix: "PIX_CPF",
      real_name: "",
      cpf: "Loading...",
      min_withdraw_amount: null,
      withdraw_rate: null,
      is_active: true,
      is_withdraled: false,
      pay_password: "",
      show_pay: false,
      need_bet: 0,
      value1: "",
      password: "",
      select_history_time: '',
      show: false,
      idCard: "",
      cy: "",
      select: "",
      re_list: [],
      totalMoney: 0.0,
      showPopup: false,
      addPassword: "",
      showBindPopup: false,
      holdBind: true,
      bindValue: "",
      allData: {},
      options: [{
        value: '选项1',
        label: 'PIX(****8287) CPF'
      }],
      bindObj: {
        name: "",
        chave_pix: "PIX_CPF",
        phone_number: "",
        cpf: ""
      },
      bindList: [],
    };
  },
  watch: {
    chave_pix: function (n, old) {
      console.log(n, old);
      if (n == "PIX_PHONE") {
        this.cpf = "+55";
      }
    },
    showPopup: function (n, old) {
      if (!n) {
        this.addPassword = ""
      }
    },
    showBindPopup: function (n, old) {
      if (!n) {
        this.bindObj = {
          name: "",
          chave_pix: "PIX_CPF",
          phone_number: "",
          cpf: ""
        }
      }
    },
    'bindObj.phone_number': function (val) {
      const isNum = val.indexOf('+55')
      if (isNum > -1) {
        this.bindObj.phone_number = this.bindObj.phone_number.replace(/\+55/, '')
      }
    }
  },
  created() {
    this.$bus.$emit("send2ftnav", 3);
  },
  mounted() {
    //验证一下有没有设置支付密码
    this.hasWithdrawPassword();
  },
  methods: {
    hiddenPhoneNumber(val) {
      if (!val || val.length < 4) {
        return val; // 如果手机号不足4位，直接返回
      }
      const visiblePart = val.slice(-4); // 取后4位
      const hiddenPart = "*".repeat(val.length - 4); // 前面用 * 代替
      return hiddenPart + visiblePart; // 返回 *******5678
    },
    addBindCon() {
      // 验证cpf格式
      if (this.bindObj.cpf.length < 9 || this.bindObj.chave_pix.length > 11) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("CPF不正确"),
          duration: 3000,
        });
        return false;
      }

      if (this.bindObj.chave_pix === "PIX_CNPJ" && !this.bindObj.pix) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("pix不能为空"),
          duration: 3000,
        });
        return false
      }
      let url = "/user/editwallet", obj = this.bindObj;

      obj = {
        name: obj.name,
        chave_pix: obj.chave_pix,
        phone_number: obj.phone_number,
        area_code: "+55",
        cpf: obj.cpf,
        id: obj.id,
        pix: obj.pix,
      }
      if (obj.chave_pix === 'PIX_PHONE') {
        obj.pix = obj.phone_number
      } else if (obj.chave_pix === 'PIX_CPF') {
        obj.pix = obj.cpf
      }
      Fetch(url, obj).then(res => {
        if (res.code == 1) {
          this.showBindPopup = false;
          this.hasWithdrawPassword();
        } else {
          this.$message.error({
            message: res.msg,
          });
        }
      })
    },
    selectPix() {
      this.bindObj.pix = ''
    },
    addaccount() {
      this.show = true;
    },
    pswChange(password) {
      console.log(password);
    },
    addPasswordChange(password) {
      console.log(password);
    },
    hasWithdrawPassword() {
      Fetch("/withdraw/init").then((res) => {
        if (res.data.is_set == 0) {
          this.$router.push("setpasswd");
        } else {
          this.allData = res;
          this.getWdAble(this.allData);
          this.initBind(this.allData);
        }
      });
    },
    updateBind(item) {
      this.showPopup = true;
      this.isUpd = true;
      this.updId = item.id;
    },
    tabChange(v) {
      this.active = v;
      if (this.active == 2) {
        Fetch("/withdraw/record", {
          date: this.select_history_time,
        }).then((r) => {
          if (r.data) {
            this.re_list = r.data;
          }
        });
      } else if (this.active == 1) {
        this.initBind(this.allData)
      } else {
        this.initBind(this.allData)
      }
    },
    initBind(data) {
      this.bindList = data.data.wallet;
      if (this.bindList.length > 0) {
        this.listActive = data.data.wallet[0].id;
        this.bindValue = data.data.wallet[0].id;
      }
    },
    changeBind(item, index) {
      this.listActive = item.id;
    },
    back() {
      this.$router.go(-1);
    },
    selectChange(value) {
      console.log(value)
    },
    onClickLeft() {
      this.$router.push("/");
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    //获取可以提现的金额
    getWdAble(data) {
      this.able_money = data.data.money;
      this.min_withdraw_amount = data.data.min_withdraw;
      this.chave_pix = data.data.chave_pix ? data.data.chave_pix : "PIX_CPF";
      this.withdraw_rate = data.data.withdraw_rate;
      this.real_name = data.data.real_name;
      this.phone_number = data.data.phone_number;
      this.need_bet = data.data.need_bet;
      this.cpf = data.data.cpf;
    },
    handleInputEnd(pay_password) {
      let bindData = {};
      this.bindList.forEach(item => {
        if (item.id == this.bindValue) {
          bindData = item;
        }
      })
      let data = {
        money: this.money,
        real_name: bindData.name,
        phone_number: bindData.phone_number,
        chave_pix: bindData.chave_pix,
        cpf: bindData.cpf,
        pix: bindData.pix,
        pay_password: pay_password,
        wallet_id: this.bindValue
      };
      if (data.chave_pix === 'PIX_PHONE') {
        data.pix = data.phone_number
      } else if (data.chave_pix === 'PIX_CPF') {
        data.pix = bindData.cpf
      }
      Fetch("/withdraw/apply", data).then((res) => {
        if (res.code == 1) {
          this.$message({
            title: "R$" + this.money,
            message: this.$t("提现成功"),
            type: "success",
          });
          setTimeout(() => {
            this.$router.push("/");
          });
        } else {
          setTimeout(() => {
            // this.$message.error({
            //   message: res.msg,
            // });
            this.$refs.payLayer.fail(res.msg);
          }, 2000);
        }
      });
    },
    handleClose() {
      this.show_pay = false;
    },
    handleForget() {
      this.$message.info({
        title: this.$t("重置提现密码"),
        message:
          this.$t("请联系平台客服解决提现密码重置问题。"),
        duration: 5000,
      });
    },
    selectHistoryimeChange() {
      this.re_list = [];
      Fetch("/withdraw/record", {
        date: this.select_history_time,
      }).then((r) => {
        if (r.data) {
          this.re_list = r.data;
        }
      });
    },
    toAddBind(value) {
      this.active = 1;
      this.initBind();
    },
    addBind() {
      this.showPopup = true;
      this.isUpd = false;
    },
    // 检验密码
    verifyPassword() {
      Fetch("/user/checkPassword", {
        pay_password: this.addPassword
      }).then(res => {
        if (res.code == 1) {
          this.showPopup = false;
          this.showBindPopup = true;
          if (!this.isUpd) return;
          if (this.bindList.length > 0) {
            let listItem = null;
            this.bindList.forEach(item => {
              if (item.id == this.updId) {
                listItem = item
              }
            })
            Object.assign(this.bindObj, listItem);
            console.log(this.bindObj)
          }
        } else {
          this.$message.error({
            message: res.msg,
          });
        }
      })

    },
    toSupport() {
      this.$parent.isShowSupport = true;
      EventBus.$emit('supTabChange', 0);
    },
    //提现
    submit() {
      if (!this.bindValue) {
        this.$message({
          message: this.$t("选择提款账户")
        });
        return;
      }
      // if (this.need_bet > 0) {
      //   this.$message({
      //     title: "Aviso gentil",
      //     message:
      //       "Você ainda precisa apostar R$" +
      //       this.need_bet +
      //       " para poder sacar",
      //   });
      //   return false;
      // }
      //没有可提现的金额
      if (this.able_money <= 0) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("当前可提现金额为0"),
          duration: 3000,
        });
        return false;
      }
      //提现金额验证
      let amount_reg = /^[1-9][0-9]*([.][0-9]{1,2})?$/;
      if (!amount_reg.test(this.money)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额不正确"),
          duration: 3000,
        });
        return false;
      }
      //提现金额 大于可提现金额
      if (Number(this.money) > Number(this.able_money)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额大于可提现金额"),
          duration: 3000,
        });
        return false;
      }

      if (Number(this.money) < Number(this.min_withdraw_amount)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额小于最低提现金额"),
          duration: 3000,
        });
        return false;
      }
      //终于通过验证了
      this.show_pay = true;
    },
  },
};
</script>



<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/.selectBind {
  color: @textcolor2;
  font-size: .3rem;
}

/deep/ .van-nav-bar--fixed {
  z-index: 2;
}

/deep/ .el-select-dropdown__item img {
  width: .8rem;
  height: .8rem;
}

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-popup--center {
  border-radius: .5rem;
}

/deep/ .el-select {
  background-color: #ccc;
  border-radius: .2rem;
  width: 85%;
}

/deep/ .el-select-dropdown__item.hover {
  background-color: transparent;
}

/deep/ .el-select-dropdown__item.hover .selectBind {
  color: @rechargeColor;
}

/deep/ .el-select-dropdown {
  background-color: @primary-color;
  border: 0.01rem solid @bodercolor;
}

/deep/.van-tab__text {
  font-size: 0.3rem;
  color: #fff;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  background-color: @primary-color;
  border: 0.01rem solid @bodercolor;
  border-radius: .2rem;
  height: 0.9rem;
  color: #fff;
  font-size: .3rem;
}

/deep/ .el-input--suffix .el-input__inner {
  background-color: @primary-color;
  border: 0.01rem solid @bodercolor;
  border-radius: .2rem;
  height: 0.9rem;
  color: #fff;
  font-size: .3rem;
}

/deep/.van-tabs__line {
  background: @ButtonColor;
  height: 0.04rem;
}

/deep/ .van-tab__text--ellipsis {
  white-space: nowrap;
}

/deep/.van-cell {
  font-size: 0.3rem;
  border-radius: 0.14rem;
  padding: 0 0.2rem;
  height: 1rem;
  border: 0.01rem solid @bodercolor !important;
  background-color: @secondary-color;
  display: flex;
  align-items: center;
}

/deep/ .van-cell::after {
  border: none;
}

/deep/ .van-field__label {
  width: auto;
}

/deep/ .van-field__label span {
  color: #fff !important;
}

/deep/ .van-button--primary {
  width: 100%;
  background-color: @rechargeColor;
  border: none;
  height: 1rem;
  border-radius: 0.2rem;
}

/deep/ .el-input--suffix .el-input__inner::placeholder {
  color: @textcolor1;
}

/deep/.van-button__text {
  color: @vipTextMoneyColor !important;
  font-size: 0.3rem;
}

/deep/ .van-popup--center {
  width: 90%;
  padding: 0.3rem;
  background-color: @secondary-color;
}

/deep/ .el-select-dropdown__empty {
  color: #fff;
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: @popupTextColor;
}

.cpfDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pasTips_bottom {
  color: #fff;
  font-size: .3rem;
  padding-left: .1rem;
}

.pasButton {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .4rem .5rem;
  width: 85%;
  background-color: @rechargeColor;
  border-radius: .3rem;
  color: @primary-color;
  font-size: .35rem;
  margin: 0 auto;
  margin-top: .5rem;
}

.bindButton {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .3rem .5rem;
  width: 85%;
  background-color: @rechargeColor;
  border-radius: .3rem;
  color: @primary-color;
  font-size: .35rem;
  margin: 0 auto;
  margin-top: .5rem;
}

.addBind_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .2rem;
  background-color: @primary-color;
  border-radius: .2rem;

  .box_title {
    display: flex;
    align-items: center;

    i {
      margin-right: .2rem;
    }
  }
}

.popup_title {
  text-align: center;
  font-size: 0.4rem;
  color: #fff;
  margin-bottom: 0.4rem;
}

.pasTitle {
  text-align: center;
  color: #fff;
  font-size: .4rem;
  margin-bottom: .5rem;
}

.pasTips {
  display: flex;
  justify-content: space-between;
  padding: 0 .3rem;

  span {
    color: #fff !important;
    font-size: .3rem;
  }

  .green {
    color: @rechargeColor !important;
  }
}

.select_items {
  display: flex;
  justify-content: space-between;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
  padding-left: 0.5rem;
}

.bind_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: .3rem;
  box-sizing: border-box;
  height: 100vh;
  position: relative;

  // height: 100%;
  .bindCard {
    padding: .2rem;
    background-color: @primary-color;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
    border-radius: .2rem;
    color: @textcolor3;

    .bindCard-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .bindCard-list {
      .list {
        border: 0.01rem solid @bodercolor;
        border-radius: 0.2rem;
        padding: 0.1rem;
        box-sizing: border-box;
        display: flex;
        position: relative;
        margin-bottom: .2rem;

        .list-center {
          flex: 1;
          margin-left: .3rem;

          span {
            margin-right: .1rem;
          }

          .copy {
            display: flex;
            align-items: center;

            img {
              width: 0.25rem;
              margin-left: .1rem;
            }
          }
        }

        .tag {
          position: absolute;
          bottom: -0.1rem;
          right: 0;

          img {
            width: 0.4rem;
          }
        }

        img {
          width: .7rem;
        }
      }

      .listActive {
        border: 0.01rem solid @rechargeColor;
      }
    }

    // height: calc(100% - 1rem);
  }

  .addBind {
    background-color: @primary-color;
    padding: .2rem .2rem .3rem;
    width: 100%;
    height: 1.5rem;
    border-top-right-radius: .2rem;
    border-top-left-radius: .2rem;
    position: fixed;
    bottom: 0;
    box-sizing: border-box;

    .pix_box {
      border: 0.01rem solid @bodercolor;
      padding: .1rem .3rem;
      border-radius: .2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: .7rem;
        height: .7rem;
      }

      .left {
        display: flex;
        align-items: center;

        i {
          margin-left: .3rem;
          color: #fff;
          font-size: .35rem;
        }
      }

      .right {
        display: flex;
        align-items: center;

        i {
          margin-left: .3rem;
          color: @ButtonColor;
          font-size: .35rem;
        }
      }
    }
  }
}

.flex_select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

select {
  height: 0.7rem;
  border: 0.01rem solid @bodercolor;
  // padding-left: 0.4rem;
  // margin-left: 0.3rem;
  font-size: 0.26rem;
  color: @popupTextColor;
}

.input_item {
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  background-color: @primary-color;
  border: 0.01rem solid @bodercolor;
  border-radius: .2rem;
  margin-top: .2rem;

  .pre {
    color: @textcolorf;
  }

  span {
    margin-left: .3rem;
    font-size: .35rem;
    color: @textcolor1;
  }

  .phoneIcon {
    width: 14px;
    height: 14px;
    mask: url(../../assets/images/common/phone.svg) center center no-repeat;
    mask-size: contain !important;
    background-color: @textcolor1;
  }
}

.kefu {
  fill: @rechargeColor;
}

select {
  border-radius: 0.5rem;
  color: #fff;
  background-color: @primary-color;
}

// @media (min-width: @maxWidth) {
//   :deep(.van-sticky) {
//     position: static !important;
//   }
// }
.bonus {
  color: @popupTextColor;
  margin-right: 0.3rem;
  font-size: 0.35rem;
  margin-top: 0.13rem;
  display: flex;
  align-items: center;

  span {
    color: @rechargeColor !important;
  }
}

.m-wrap path {
  fill: @rechargeColor;
}

.stroke_path {
  stroke: @primary-color;
}

.addSvg {
  fill: @ButtonColor;
}

.left_svg {
  fill: @popupTextColor;
  transform: rotate(180deg);
}

.addText {
  font-size: 0.3rem;
  color: @popupTextColor;
  margin-left: 0.3rem;
}

.lock_icon {
  font-size: 0.45rem;
  color: #fff;
}

.fst_pw {
  width: 94%;
  margin: 0.2rem auto 0.2rem auto;
}

.vantTabs {
  // padding-top: .2rem;
  width: calc(100% - 1.8rem);
  overflow-x: scroll;

  :deep(.van-sticky) {
    width: 100%;
    max-width: @maxWidth;
    // left: 50%;
    // transform: translateX(-50%);
  }

  :deep(.van-tabs__wrap) {
    height: 0.88rem;

    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
      width: calc(100%);
      overflow-x: scroll;
    }

    .van-tab {
      padding: 0 0.2rem;

      .van-tab__text {
        font-size: 0.32rem;
      }

      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }

    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}

/deep/ .van-tabs__nav {
  padding-left: 0;
  padding-right: 0;
  background-color: @secondary-color;
}

.left_div {
  display: flex;
  align-items: center;
  border-bottom: 1px solid @bodercolor;
  background-color: @secondary-color;
  padding: 4px 0 2px;

  .left {
    margin-left: 0.3rem;

    svg {
      fill: #fff;
    }
  }
}

.password_title {
  font-size: 0.3rem;
  color: #fff;
  line-height: 0.5rem;
}

.password {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .password_title {
    font-size: 0.3rem;
    color: #fff;
  }
}

.wdAble {
  margin-left: 0.2rem;
}

.rmoney {
  color: @ButtonColor !important;
  border-bottom: 0.01rem solid @ButtonColor;
}

.wdAble svg {
  fill: @ButtonColor;
}

.money_title {
  font-size: 0.3rem;
  color: @textcolor2;
}

.ablewd ul {
  width: 100%;
  padding: 0.3rem 0;
  display: flex;
  align-items: center;
  margin: initial;
}

.ablewd ul li {
  flex: 1;
  border: thin solid @ButtonColor;
  box-sizing: border-box;
  color: @ButtonColor;
  height: 1rem;
  border-radius: 0.2rem;
  display: flex;
  font-size: 0.2rem;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
}

.ablewd ul li span {
  color: @ButtonColor !important;
}

.choseDiv {
  position: absolute;
  bottom: -0.03rem;
  right: -0.01rem;
}

.addAccount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: @secondary-color;
  border: thin solid @bodercolor;
  border-radius: 0.14rem;
  font-size: 0.22rem;
  height: 1rem;
  margin-bottom: 0.5rem;
  text-indent: 0.05rem;
  padding: 0 0.15rem;
  position: relative;
  box-sizing: content-box;
}

.left_add {
  display: flex;
  align-items: center;
}

.order-status {
  width: 100%;
  box-sizing: border-box;
  //   padding: 0.1rem 0 0.1rem 15px;
  padding: 0.26316rem 0.26316rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //   border-bottom: thin solid #e5e5e5;
}

.mmm {
  //   width: 100%;
  font-weight: 700;
  color: gold;
}

.money3 {
  //   width: 95%;
  margin: 0 auto;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  //border-bottom: thin solid rgba(126, 126, 126, 0.1);
}

.unpay {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  color: #fc661e;
  //background:  linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.status {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  //background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));
}

.order {
  font-size: 0.3rem;
}

.jinbi {
  height: 0.32rem;
  margin-left: 0.2rem;
}

.refresh_btn {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}

.logo {
  width: 100%;
  text-align: center;

  img {
    width: 80%;
  }
}

.myteam-bg {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.cantc {
  background-color: rgb(22, 22, 19) !important;
  font-weight: 700;
}

.base-header {
  position: relative;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 92%;
  margin: 0 auto 0.2rem auto;
  border-radius: 0.2rem;
  overflow: hidden;
  z-index: 1;
  border: thin solid #0f69e8;
  box-sizing: border-box;
  padding: 5px 5px;
}

.big_tit {
  font-size: 0.35rem;
  text-align: center;
  width: 49%;
  height: 0.7rem;
  line-height: 0.7rem;
  color: #ffffff;
  border-radius: 0.1rem;
}

.recharge-one {
  width: 90%;
  margin: 0 auto 0.3rem auto;
  border-radius: 8px;
  color: #fff;
  overflow: hidden;
  position: relative;
  //border: 1px solid #895DB3;
  background: @secondary-color;
  padding: 0 0;
  font-size: 0.3rem;
}

.is-active {
  color: #ffffff;
  background-image: linear-gradient(90deg,
      rgba(3, 38, 96, 0.84) 0,
      rgba(3, 38, 96, 0.84) 0,
      rgb(27, 64, 119) 100%,
      rgb(27, 64, 119) 100%);
}

.fee {
  color: #fff;
  margin-top: 0.2rem;
}

.amount-input {
  height: 1rem;
  width: 100%;
  background-color: @primary-color;
  // background-color: none;
  //border: thin solid #293548;
  border-radius: .2rem;
  border: none;
  // margin-top: 10px;
  font-size: 14px;
  color: white;
  text-indent: 10px;
  // border-radius: 5px;
  //background: transparent;
  // font-weight: 700;
  box-sizing: border-box;
  // border: 0.01rem solid @bodercolor !important;
  //box-sizing: border-box;
}

.selectpix {
  // color: #e5c616 !important;
  font-size: 0.33rem;
  color: @textcolor1 !important;
  font-size: 0.3rem;
  background-color: @primary-color !important;
  border: none;
  outline: none;
  /* 设置下拉选择框的背景颜色 */
}

.blueSvg {
  fill: @textcolor1;
}

.amount-input::placeholder {
  font-size: 12px;
  color: @textcolor1;
}

.enther {
  // width: 92%;
  // margin: 15px auto 10px auto;
  box-sizing: border-box;
  // background-color: @secondary-color;
  padding: 0.3rem 0.2rem;
  border-bottom: 0.01rem solid @bodercolor;
}

.endes {
  color: #fff;
  font-size: 0.32rem;
  margin: 0;
}

.desc-num {
  margin-left: 0.1rem;
  color: gold;
  font-size: 0.35rem;
  font-weight: 700;
}

.desc-ab {
  text-align: left;
  box-sizing: border-box;
}

.left-ab {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
}

.right-ab {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ablewd {
  // width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}

.free-count {
  color: #989da6;
}

.basic_btn {
  background: #fff;
  margin: 15px auto 0;
  background-size: 100%;
  color: #132816;
  font-weight: 700;
}

.withdraw_wrap {
  width: 100%;
  height: 100vh;
  // height: auto;
  // padding-top: 0.2rem;
  //background-color: rgba(0,0,0,0.5);
  background-color: @activityColor;
}

.sbtn {
  margin: 0.5rem auto 0.5rem auto;
  width: 92%;
  border-radius: 0.2rem;
  font-size: 0.35rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: @anttextcolor;
  color: @primary-color;
}
</style>